import { Icon } from "@iconify/react/dist/iconify.js";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center">
            <script>document.write(new Date().getFullYear())</script>
            2025 Crafted by
            <Icon icon="solar:hearts-bold-duotone" className="fs-18 align-middle text-danger"></Icon>
            <a href="https://www.ayatas.com/" className="fw-bold footer-text" target="_blank">
              Ayatas Technologies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
